import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["RobotsInspectorTool"] */ "/app/src/components/tools/RobotsInspectorTool.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RobotsSitemapFaq"] */ "/app/src/components/tools/RobotsSitemapFaq.tsx");
